import axios from 'axios';
import { normalizeLocalizedData } from './utils';

const rawBackendUrl = (process.env.REACT_APP_BACKEND_URL || '').trim();
const BACKEND_URL = ['undefined', 'null'].includes(rawBackendUrl)
  ? ''
  : rawBackendUrl.replace(/\/$/, '');
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('bf_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  // Add language parameter to all requests
  const lang = localStorage.getItem('bf_lang') || 'en';
  const separator = config.url?.includes('?') ? '&' : '?';
  config.url = `${config.url}${separator}lang=${lang}`;
  return config;
});

api.interceptors.response.use(
  (response) => {
    response.data = normalizeLocalizedData(response.data);
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('bf_token');
      localStorage.removeItem('bf_user');
    }
    return Promise.reject(error);
  }
);

export default api;
